import React from 'react';
import { Box, TextInput, Button, Select, Text, Grid } from '@mantine/core';
import type { IFiltroUsuariosVistaProps } from '../interfaces';
import { IconSearch, IconClearAll, IconBuildingSkyscraper, IconTimezone, IconAt, IconWorldPin, IconUser } from '@tabler/icons-react';

const FiltroUsuariosVista: React.FunctionComponent<IFiltroUsuariosVistaProps> = ({
    filtro,
    consultarUsuarios,
    manejarCambioFiltroUsuario,
    limpiarFiltros,
    entidadesFiltro,
}) => {
    return (
        <Box pb="sm">
            <Grid gutter="sm">
                <Grid.Col span={{ base: 12, md: 2 }}>
                    <TextInput
                        size='xs'
                        label="Nombre"
                        leftSection={<IconUser size={14} />}
                        placeholder="Buscar por nombre..."
                        value={filtro.Nombre ? filtro.Nombre : ''}
                        onChange={(event) => manejarCambioFiltroUsuario('Nombre', event.currentTarget.value)}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2 }}>
                    <TextInput
                        label="Email"
                        size='xs'
                        leftSection={<IconAt size={14} />}
                        placeholder="Buscar por email..."
                        value={filtro.Email ? filtro.Email : ''}
                        onChange={(event) => manejarCambioFiltroUsuario('Email', event.currentTarget.value)}
                    />
                </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 2 }}>
                    <Select
                        label="País"
                        placeholder="País"
                        searchable
                        size="xs"
                        leftSection={<IconWorldPin size={14} />}
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesFiltro.Paises.map(c => ({
                            value: c.Id.toString(),
                            label: c.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron paises"
                        value={filtro.PaisId ? filtro.PaisId.toString() : null}
                        clearable
                        onChange={(value) => {
                            manejarCambioFiltroUsuario("PaisId", value ? Number(value) : 0)
                        }}
                    />
                </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 2 }}>
                    <Select
                        label="Regional"
                        placeholder="Regional"
                        searchable
                        size="xs"
                        leftSection={<IconTimezone size={14} />}
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesFiltro.RegionalesFiltro.map(c => ({
                            value: c.Id.toString(),
                            label: c.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron regionales"
                        value={filtro.RegionalId ? filtro.RegionalId.toString() : null}
                        clearable
                        onChange={(value) => {
                            manejarCambioFiltroUsuario("RegionalId", value ? Number(value) : 0)
                        }}
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 2 }}>
                    <Select
                        label="Ciudad"
                        placeholder="Ciudad"
                        searchable
                        size="xs"
                        leftSection={<IconBuildingSkyscraper size={14} />}
                        comboboxProps={{ zIndex: 5000 }}
                        data={entidadesFiltro.CiudadesFiltro.map(c => ({
                            value: c.Id.toString(),
                            label: c.Nombre,
                        }))}
                        nothingFoundMessage="No se encontraron ciudades"
                        value={filtro.CiudadId ? filtro.CiudadId.toString() : null}
                        clearable
                        onChange={(value) => {
                            manejarCambioFiltroUsuario("CiudadId", value ? Number(value) : 0)
                        }}
                    />
                </Grid.Col>

                <Grid.Col
                    span={{ base: 12, md: 2 }}
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                    }}
                >
                    <Button
                        onClick={limpiarFiltros}
                        color="primary"
                        variant="light"
                        size="compact-sm"
                        radius="lg"
                        fullWidth
                        rightSection={<IconClearAll opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Limpiar</Text>
                    </Button>

                    <Button
                        onClick={() => consultarUsuarios(filtro)}
                        color="primary"
                        variant="filled"
                        size="compact-sm"
                        fullWidth
                        radius="lg"
                        rightSection={<IconSearch opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Consultar</Text>
                    </Button>
                </Grid.Col>
            </Grid>
        </Box>
    );
};

export default FiltroUsuariosVista;
